import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { useNavigate } from 'react-router-dom';
import TextLevelingTool from './TextLevelingTool';
import ProgressBarWithCircles from '../Layout/ProgressBar';
import classes from './TextLeveling.module.css';
import ToolDescription from '../../common/toolDescription';
import ToolImage from '../../images/tool.png';
import '../../common/common_styles.css';
import { Tooltip } from '@mui/material';
import { useAppUsageLogger } from "../../slices/authApi";

const TextLevelingPage = () => {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(33); // Initial progress
    const logAppUse = useAppUsageLogger();

    useEffect(() => {
        logAppUse("text_leveling_page", "page_load");
    }, []); // Empty dependency array to run only on mount


    // Function to call when Generate is clicked in the child component
    const handleGenerate = () => {
        setProgress(100); // Set progress to 100 when text is generated
    };

    return (
        <div className="page-margin">
            <section aria-label="Text leveling content" className="app-main">
                <div className={classes.pageHeader}>
                    <h1 className={classes.pageTitle}>Text Complexity Adjustment Tool</h1>
                </div>

                <ProgressBarWithCircles progress={progress} />

                <div className="videoAndTool" style={{ maxWidth: '900px', margin: '0 auto 20px auto', justifyContent: 'center' }}>
                    <ToolDescription
                        image={ToolImage}
                        heading={"Adjust text complexity to students' abilities"}
                        description={
                            <>
                                This tool helps you adjust the complexity of your text to make it more accessible
                                for your target audience. Simply paste your text, select your desired grade level
                                or{" "}
                                <Tooltip
                                    title={
                                        `Lexile® is a registered trademark of MetaMetrics, Inc. ` +
                                        `This tool is not affiliated with MetaMetrics and does not ` +
                                        `generate official Lexile® measures. Coming soon.`
                                    }
                                >
                                    <span>
                                        <span style={{ textDecoration: "underline", cursor: "help" }}>
                                            Lexile
                                        </span>
                                        ®
                                    </span>
                                </Tooltip>
                                , and the tool will generate a version of your text that matches
                                the selected complexity level using AI-based estimates. This is perfect for adapting
                                materials to various reading abilities.
                            </>
                        }
                    />
                </div>

                <TextLevelingTool onGenerateClick={handleGenerate} />
            </section>
        </div>
    );
};

export default TextLevelingPage;